import api from './api';

/**
 * Service for retrieving ad insights data (advertisers + off-Facebook activity).
 */
export const adInsightsService = {
  /**
   * Fetch stored ad insights for a user.
   * @param {string|{username?: string, userId?: string}} usernameOrOpts - Display username, or options with userId (matches findings API).
   * @returns {Promise}
   */
  getAdInsights: async (usernameOrOpts) => {
    try {
      const params = {};
      if (typeof usernameOrOpts === 'string') {
        params.username = usernameOrOpts;
      } else if (usernameOrOpts && typeof usernameOrOpts === 'object') {
        if (usernameOrOpts.username) params.username = usernameOrOpts.username;
        if (usernameOrOpts.userId) params.user_id = usernameOrOpts.userId;
      }
      const response = await api.get('/privacy/ad_insights/', {
        params,
      });
      return response.data;
    } catch (error) {
      console.error('Get ad insights error:', error);
      throw error;
    }
  },
};

export default adInsightsService;
